import React from "react";

import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Select.module.css";

type SelectOption = Record<string, unknown>;
type SelectValue = string | SelectOption;

// NOTE: these props are passed by Material UI Select component internally
interface MuiSelectItemProps<T extends SelectValue> {
  "aria-selected": "true" | "false";
  "data-value": T;
  onClick: () => void;
  onKeyUp: () => void;
  role: string;
  selected: boolean;
}

type SelectItemProps<T extends SelectValue> = Partial<MuiSelectItemProps<T>> & {
  className?: string;
  label: string;
  value: T;
  indentation?: boolean;
  preAdornment?: React.ReactNode;
  postAdornment?: React.ReactNode;
};

export default function SelectItem<T extends SelectValue>({
  className,
  label,
  value,
  indentation,
  preAdornment,
  postAdornment,
  ...restProps
}: SelectItemProps<T>): JSX.Element {
  return (
    <MenuItem
      className={toClassName(styles.menuItem, className, {
        [styles.menuItemIndentation]: indentation,
      })}
      {...restProps}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {preAdornment}
        <Typography className={styles.menuItemText}>{label}</Typography>
        {postAdornment}
      </Stack>
    </MenuItem>
  );
}
